export const ONLINE_PAYMENT_LIMIT = 10000;
export const ONLINE_PAYMENT_LIMIT_LABEL = "£10,000";

export const exceedsOnlinePaymentLimit = (value) =>
  Number(value) > ONLINE_PAYMENT_LIMIT;
